import dayjs from "dayjs";
import countriesEn from "i18n-iso-countries/langs/en.json";
import countriesSv from "i18n-iso-countries/langs/sv.json";
import countriesDa from "i18n-iso-countries/langs/da.json";
import countriesNo from "i18n-iso-countries/langs/no.json";
import languagesEn from "@cospired/i18n-iso-languages/langs/en.json";
import languagesSv from "@cospired/i18n-iso-languages/langs/sv.json";
import languagesDa from "@cospired/i18n-iso-languages/langs/da.json";
import languagesNo from "@cospired/i18n-iso-languages/langs/no.json";

export const registerSupportedTranslations = (
  countries: any,
  languages: any
) => {
  countries.registerLocale(countriesEn);
  countries.registerLocale(countriesSv);
  countries.registerLocale(countriesDa);
  countries.registerLocale(countriesNo);
  languages.registerLocale(languagesEn);
  languages.registerLocale(languagesSv);
  languages.registerLocale(languagesDa);
  languages.registerLocale(languagesNo);
};

const dayjsLocales: { [key: string]: any } = {
  en: () => import("dayjs/locale/en"),
  da: () => import("dayjs/locale/da"),
  fi: () => import("dayjs/locale/fi"),
  nb: () => import("dayjs/locale/nb"),
  sv: () => import("dayjs/locale/sv"),
};

export const loadDayjsLocale = (language: string) => {
  if (dayjsLocales[language]) {
    dayjsLocales[language]().then(() => dayjs.locale(language));
  }

  return;
};
